import { useEffect } from 'react';
import logger from '../helpers/logger';
import { store } from '../stores/store';

function categorizeKey(key: string): string {
	if (/^[0-9]$/.test(key)) return 'digit';
	if (/^[a-zA-Z]$/.test(key)) return 'letter';
	if (['Backspace', 'Delete'].includes(key)) return 'delete';
	if (['Enter', 'Tab', 'Escape'].includes(key)) return 'control';
	if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(key)) return 'navigation';
	if (['Shift', 'Control', 'Alt', 'Meta', 'CapsLock'].includes(key)) return 'modifier';
	if (key === ' ') return 'space';
	return 'special';
}

export function useKeypressLogger() {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (!store.sessionStore.isActive) return;
			const target = e.target as HTMLElement;
			const fieldName = target.getAttribute('name') ?? target.tagName.toLowerCase();
			const category = categorizeKey(e.key);
			logger.logGeneral.log({}, `Keypress: category=${category}, field=${fieldName}`, 'keypress-logger', true);
		};

		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, []);
}
